import { render, staticRenderFns } from "./Estudiantes.vue?vue&type=template&id=66e2eea1"
import script from "./Estudiantes.vue?vue&type=script&lang=js"
export * from "./Estudiantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports